import { render, staticRenderFns } from "./merchantPayInRotation.vue?vue&type=template&id=8d735d28&scoped=true"
import script from "./merchantPayInRotation.vue?vue&type=script&lang=js"
export * from "./merchantPayInRotation.vue?vue&type=script&lang=js"
import style0 from "./merchantPayInRotation.vue?vue&type=style&index=0&id=8d735d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d735d28",
  null
  
)

export default component.exports